// BloomOverlay.js

'use strict'

var HighPassShader = require( './HighPassShader.js' );

var BlurPassShader = require( './BlurPassShader.js' );

var OverlayPassShader = require( './OverlayPassShader.js' );

var BloomOverlay = function( w, h, options ){

  this.width = w;
  this.height = h;

  this.opacity = 0.75;

  this.blurstep = 1;

  this.blurScale = 1;

  this.iterations = 2;

  this.hi = 1;
  this.lo = 0.5;

  this.writeBuffer;
  this.readBuffer;

  var renderTargetOptions = {
    minFilter: THREE.LinearFilter,
    magFilter: THREE.LinearFilter, 
    format: THREE.RGBAFormat
  }

  // set custom attributes
  for(var i in options){
    this[i] = options[i];
  }


  // create the buffers(if necessary)
  if(!this.writeBuffer){ 
    this.writeBuffer = new THREE.WebGLRenderTarget( 
      this.width,
      this.height,
      renderTargetOptions ); 
  }

  if(!this.readBuffer) {
    this.readBuffer = new THREE.WebGLRenderTarget( 
      this.width,
      this.height,
      renderTargetOptions );
  }


  // pass materials
  this.hiMat = new THREE.ShaderMaterial( HighPassShader );
  this.blurMat = new THREE.ShaderMaterial( BlurPassShader );
  this.blurMat.uniforms.resolution.value.set( this.width, this.height );
  this.overlayMat = new THREE.ShaderMaterial( OverlayPassShader );

  // full screen texture
  this.quadScene = new THREE.Scene();
  
  this.quad = new THREE.Mesh( new THREE.PlaneBufferGeometry( 2, 2 ), this.overlayMat );
  this.quad.frustumCulled = false;

  this.quadScene.add( this.quad );

}



BloomOverlay.prototype.render = function(renderer, scene, camera){

  // draw the scene into our buffer
  renderer.render(scene, camera, this.readBuffer, true);


  // blur passes
  this.swapBuffers();
  this.blurMat.uniforms.blurScale.value = this.blurScale;
  for(var i=0; i<this.iterations; i++){

    this.swapBuffers();
    this.blurMat.uniforms.direction.value.set( this.blurstep, 0 );
    this.renderPass( renderer, camera, this.blurMat );

    this.swapBuffers();
    this.blurMat.uniforms.direction.value.set( 0, this.blurstep );
    this.renderPass( renderer, camera, this.blurMat );
  }

  // // high pass
  // this.hiMat.uniforms.hi.value = this.hi;
  // this.hiMat.uniforms.lo.value = this.lo;
  // this.renderPass( renderer, camera, this.hiMat );

  // draw to the screen
  this.swapBuffers();
  this.overlayMat.uniforms['opacity'].value = this.opacity;
  this.renderToScreen(renderer, camera, this.overlayMat);
}



BloomOverlay.prototype.swapBuffers = function(){
  var s = this.writeBuffer;
  this.writeBuffer = this.readBuffer;
  this.readBuffer = s;
}



BloomOverlay.prototype.renderPass = function(renderer, camera, material){

  material.uniforms['tDiffuse'].value = this.readBuffer.texture;
  
  this.quadScene.overrideMaterial = material;
  
  renderer.render(this.quadScene, camera, this.writeBuffer, true);

  this.quadScene.overrideMaterial = null;
}



BloomOverlay.prototype.renderToScreen = function(renderer, camera, material){

  material.uniforms['tDiffuse'].value = this.readBuffer.texture;
  
  this.quadScene.overrideMaterial = material;
  
  renderer.render(this.quadScene, camera, null, false);

  this.quadScene.overrideMaterial = null;
}

BloomOverlay.prototype.setSize = function(w, h){

  this.width = w;
  this.height = h;

  this.writeBuffer.setSize(w, h);
  this.readBuffer.setSize(w, h);

  this.blurMat.uniforms.resolution.value.set( w, h );
}




module.exports = BloomOverlay;